import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { DBContext } from './DBContext';

const ProtectedRoute = ({ children, permission }) => {
    const isLoggedIn = localStorage.getItem('USER');
    const { hasPermission } = useContext(DBContext);

    if (!isLoggedIn) {
        return <Navigate to="/" />;
    }

    if (permission && hasPermission && !hasPermission(permission)) {
        return <Navigate to="/TableView" replace />;
    }

    return children;
};

export default ProtectedRoute;
